import 'whatwg-fetch';
import { BASE_ENDPOINT_VAI_E_VEM, ENDPOINTS } from './endpoints';

const apiDomain = 'http://api.gcn.com'; // eslint-disable-line

const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
const localhostAPIURLs = {
  geral: 'http://localhost:8000',
  votos: 'http://localhost:8000',
};

const apiToUse = isLocalhost ? localhostAPIURLs : ENV_URLS; // eslint-disable-line

/**
 * @param {String} ID Project ID
 * @param {String} projectProperty Project ID
 * @param {String} method HTTP Method
 * @param {Object} data Data to send
 * @returns {Promise}
 */
export function fetchProjects(ID = '', projectProperty = '', method = 'GET', data = null) {
  const body = data ? JSON.stringify(data) : null;

  return fetch(`${apiToUse.geral}${BASE_ENDPOINT_VAI_E_VEM}${ENDPOINTS.projetos}${ID}/${projectProperty}`, {
    method,
    body,
  }).then(response => response.json())
    .catch(error => console.log('parsing failed', error));
}

/**
 * @param {String} ID Project ID
 * @param {Number} page Current page
 * @param {String} method HTTP Method
 * @returns {Promise}
 */
export function fetchTransactionsByStatus(ID = '', page = '1', method = 'GET') {
  return fetch(`${apiToUse.geral}${BASE_ENDPOINT_VAI_E_VEM}${ENDPOINTS.status}${ID}/transacoes/?page=${page}&is_home=${true}`, {
    method,
  }).then(response => response.json())
    .catch(error => console.log('parsing failed', error));
}

/**
 * @param {String} ID Project ID
 * @param {Number} page Current page
 * @param {String} method HTTP Method
 * @returns {Promise}
 */
export function fetchTeamTransactions(ID = '', page = '1', method = 'GET') {
  return fetch(`${apiToUse.geral}${BASE_ENDPOINT_VAI_E_VEM}${ENDPOINTS.clubes}${ID}/transacoes/?page=${page}`, {
    method,
  }).then(response => response.json())
    .catch(error => console.log('parsing failed', error));
}

/**
 * @param {String} ID Project ID
 * @param {String} situation Situation
 * @param {Number} page Current page
 * @param {String} method HTTP Method
 * @returns {Promise}
 */
export function fetchMoreTeamTransactions(ID = '', situation = 'chegando', page = '1', method = 'GET') {
  return fetch(`${apiToUse.geral}${BASE_ENDPOINT_VAI_E_VEM}${ENDPOINTS.clubes}${ID}/transacoes/?situacao=${situation}&page=${page}`, {
    method,
  }).then(response => response.json())
    .catch(error => console.log('parsing failed', error));
}

/**
 * @param {Number} responseID Current page
 * @returns {Promise}
 */
export function voteInTransaction(responseID = 0) {
  return fetch(`${apiToUse.votos}/votes/simples/`, {
    method: 'POST',
    body: JSON.stringify({
      votos: [
        {
          id_voto: responseID,
        },
      ],
    }),
  }).then(response => response.json())
    .catch(error => console.log('parsing failed', error));
}

/**
 * @param {Number} ID Vai e vem IF
 * @param {Number} teamID Team ID
 * @returns {Promise}
 */
export function fetchStatistics(ID = 0, teamID = undefined) {
  const formattedTeamID = teamID ? `?clube=${teamID}` : '';

  return fetch(`${apiToUse.geral}${BASE_ENDPOINT_VAI_E_VEM}/projetos/${ID}/estatisticas${formattedTeamID}`, {
    method: 'GET',
  }).then(response => response.json())
    .catch(error => console.log('parsing failed', error));
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/api/api.js